<template>
  <div class="main">
    <HeaderTitle title="Order Status">
      <IconTable color="#14444f" size="w-11 h-11" />
    </HeaderTitle>
    <MainContent>
      <DatePickerLabel
        v-model:formControlName="dateFilter"
        @onClickApply="onApply"
      />

      <div class="pt-5 flex flex-col md:flex-row md:justify-between gap-3">
        <CardOrderStatus
          title="Planet Scenes"
          :total="formatNum(summary.total_scene)"
          :loading="orderStatus.loading"
        />
        <CardOrderStatus
          title="Planet Orders"
          :total="formatNum(summary.total_orders)"
          :loading="orderStatus.loading"
        />
        <CardOrderStatus
          title="Post Orders"
          :total="formatNum(summary.total_post_orders)"
          :loading="orderStatus.loading"
        />
      </div>

      <div class="pt-8 pb-5" v-if="!orderStatus.loading">
        <div
          class="overflow-x-auto relative shadow-md rounded-lg"
          v-if="orderStatus.rows?.length != 0"
        >
          <table class="w-full text-sm text-left text-gray-500">
            <thead>
              <tr class="bg-white border-b text-center">
                <th scope="row" class="py-3 px-2">#</th>
                <th scope="row" class="py-3 px-2">Tanggal</th>
                <th scope="row" class="py-3 px-2">Total Planet Scenes</th>
                <th scope="row" class="py-3 px-2">Total Planet Orders</th>
                <th scope="row" class="py-3 px-2">Total Post Orders</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-white border-b"
                v-for="(item, index) in orderStatus.rows"
                :key="index"
              >
                <td class="py-3 px-2 text-center">
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-3 px-2">
                  {{ item.date != null ? formatDate(item.date) : "" }}
                </td>
                <td class="py-3 px-2 text-center">
                  {{ formatNum(item.planet_scenes) }}
                </td>
                <td class="py-3 px-2 text-center">
                  {{ formatNum(item.planet_orders) }}
                </td>
                <td class="py-3 px-2 text-center">
                  {{ formatNum(item.post_orders) }}
                </td>
              </tr>
            </tbody>
          </table>

          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>
      </div>

      <LoadingLottie v-if="orderStatus.loading" />

      <div class="flex justify-center" v-if="orderStatus.rows?.length == 0">
        <NoData size="w-full md:w-5/12" />
      </div>
    </MainContent>
  </div>
</template>
<script>
import HeaderTitle from "@/components/HeaderTitle.vue";
import IconTable from "@/components/icons/IconTable.vue";
import MainContent from "@/components/MainContent.vue";
import DatePickerLabel from "@/components/DatePickerWithLabel.vue";
import CardOrderStatus from "@/components/CardOrderStatus.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import NoData from "@/components/NoData.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import { onMounted, reactive, ref } from "vue";
import { useOrderStatusStore } from "@/store";
import { storeToRefs } from "pinia";
import moment from "moment";

export default {
  components: {
    HeaderTitle,
    IconTable,
    MainContent,
    DatePickerLabel,
    CardOrderStatus,
    LoadingLottie,
    NoData,
    PaginationComponent,
  },
  setup() {
    const orderStatusStore = useOrderStatusStore();
    const { orderStatus } = storeToRefs(orderStatusStore);

    const dateFilter = ref(null);
    const length = ref(0);
    const limit = ref(20);
    const offset = ref(0);
    const page = ref(1);

    const summary = reactive({
      total_scene: 0,
      total_orders: 0,
      total_post_orders: 0,
    });

    const getOrderStatus = async () => {
      await orderStatusStore.getOrderStatus({});
      summary.total_scene = orderStatus.value.summary.total_scene;
      summary.total_orders = orderStatus.value.summary.total_orders;
      summary.total_post_orders = orderStatus.value.summary.total_post_orders;
      length.value = orderStatus.value.count;
    };

    onMounted(() => {
      getOrderStatus();
    });

    const onApply = async () => {
      offset.value = 0;
      page.value = 1;
      let dataparams = { offset: offset.value };

      if (dateFilter.value != null) {
        dataparams = {
          ...dataparams,
          startdate: moment(dateFilter.value[0]).format("YYYY-MM-DD"),
          enddate: moment(dateFilter.value[1]).format("YYYY-MM-DD"),
        };
      }

      await orderStatusStore.getOrderStatus(dataparams);
      summary.total_scene = orderStatus.value.summary.total_scene;
      summary.total_orders = orderStatus.value.summary.total_orders;
      summary.total_post_orders = orderStatus.value.summary.total_post_orders;
      length.value = orderStatus.value.count;
    };

    const formatNum = (value) => {
      return value.toLocaleString("id-ID");
    };

    const formatDate = (value) => {
      return moment(value).format("DD MMM YYYY");
    };

    const changePage = async (value) => {
      page.value = value;
      offset.value = page.value - 1;
      let dataparams = { offset: offset.value };

      if (dateFilter.value != null) {
        dataparams = {
          ...dataparams,
          startdate: moment(dateFilter.value[0]).format("YYYY-MM-DD"),
          enddate: moment(dateFilter.value[1]).format("YYYY-MM-DD"),
        };
      }

      await orderStatusStore.getOrderStatus(dataparams);
      summary.total_scene = orderStatus.value.summary.total_scene;
      summary.total_orders = orderStatus.value.summary.total_orders;
      summary.total_post_orders = orderStatus.value.summary.total_post_orders;
      length.value = orderStatus.value.count;
    };

    return {
      summary,
      orderStatus,
      dateFilter,
      length,
      limit,
      page,
      onApply,
      formatNum,
      formatDate,
      changePage,
    };
  },
};
</script>
<style></style>
